export default "__VITE_ASSET__Cjj$b8ZF__"